var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_header"},[_vm._t("left"),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }